import React, { useEffect } from 'react'
import { Dialog, SlideProps, Slide } from '@mui/material';
import { useInterestedFilterStore } from 'src/stores/InterestedStore';

// 모달창 슬라이드 트랜지션 스타일
const Transition = React.forwardRef(function Transition(
props: SlideProps,
ref: React.Ref<unknown>
) {
return <Slide direction="up" ref={ref} {...props} timeout={500} />;
});

//로직 영역
const FilterInterseted = () => {
  const isOpen = useInterestedFilterStore((state)=>state.isOpen)
  const setOpen = useInterestedFilterStore((state)=>state.setOpen)
  const element = useInterestedFilterStore((state)=>state.element)
  const setField = useInterestedFilterStore((state)=>state.setField)

  useEffect(()=>{
    if(isOpen === false){
      setField('elementValue','')
    }
  },[isOpen])

  return (
    <Dialog
        open={isOpen}
        onClose={()=>setOpen(false)}
        fullWidth
        TransitionComponent={Transition}
        PaperProps={{
          sx: {
            position: 'fixed',
            bottom: 0,
            margin: 0,
            width: '100vw',
            height: 'auto',
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
          }
        }}
      >
        {element}
      </Dialog>
  )
}

export default FilterInterseted